import {
  SAVE_MOBILIZE_DATA
} from './mutations-types'
import Mobilize from '../../../mobilize/Mobilize'
import helpers from '../../../helpers/functions'

export default {
  async fetchMobilizeDataWithPreview ({ commit }, { params }) {
    const mobilize = new Mobilize()
    try {
      let data = []
      data = await mobilize.getPreviewData(params)
      commit(SAVE_MOBILIZE_DATA, data)
      data = await mobilize.get(params)
      commit(SAVE_MOBILIZE_DATA, data)
      return true
    } catch (e) {
      helpers.handleError(e)
    }
  }
}
